module.exports = __webpack_public_path__ + "static/logo_WIM-f57d2f2455c7d9473df04350aeb25364.png";